export default __webpack_public_path__ + "static/media/IMG_9004 copie.f6cc3e22.jpg";